import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Container = styled.div`
  padding: 24px 16px;
  width: 100%;

  background: ${theme.colors.white};
  box-shadow: 0px 6px 15px rgba(37, 42, 49, 0.1);
  border-radius: ${theme.border.xsmallRadius};
  border-bottom: 3px solid #DF5605;

  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

export const Header = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`

export const IconWrapper = styled.div`
  width: 2rem;
  height: 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${theme.colors.lightYellow};
  border-radius: ${theme.border.smallRadius};
`

export const TitleWrapper = styled.div`
  & > h3 {
    font-family: ${theme.font.inter};
    font-weight: ${theme.font.normal};
    font-size: 1rem;
    line-height: 1.1875rem;
    letter-spacing: -0.02em;
    color: ${theme.colors.darkGray};
  }
`

export const Value = styled.p`
  font-family: ${theme.font.inter};
  font-weight: ${theme.font.bold};
  font-size: 1.875rem;
  line-height: 2.25rem;
  letter-spacing: -0.02em;
  color: ${theme.colors.blackLight};
`

export const TooltipWrapper = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
`
